import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { RefreshRequestDto } from "../generated/schema";

export function useRefresh() {
	const mutation = $api.useMutation("post", "/auth/refresh");
	return useMutation({
		mutationFn: async (data: RefreshRequestDto) => {
			try {
				const result = await mutation.mutateAsync({
					body: data,
					headers: {
						"x-auth-request": "true",
					},
					credentials: "include",
				});

				return result;
			} catch (error) {
				throw error;
			}
		},
	});
}
